const UserDetail = ({ responseData }) => {
  const dateStr = responseData?.date_of_joining;
  const formattedDate = dateStr
    ? new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(new Date(dateStr))
    : "";

  return (
    <>
      <section className="bg-white p-6 shadow-sm border w-full rounded-lg mt-8">
        <div className=" justify-between items-center flex-wrap gap-4">
          {/* Left: User Info */}
          <div className="flex flex-col">
            <h2 className="text-xl mb-3 font-bold text-gray-800">
              {responseData?.name?.full_name}
            </h2>
            <div className="flex mt-2 gap-6 text-sm text-gray-600 flex-wrap">
              <div className="flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Joining Date</p>
                <p className="font-bold">{formattedDate} </p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Designation</p>
                <p className="font-bold">{responseData?.designation}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Department</p>
                <p className="font-bold">{responseData?.function}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Location</p>
                <p className="font-bold">{responseData?.location?.corporate}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Mobile</p>
                <p className="font-bold">{responseData?.mobile}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Email</p>
                <p className="font-bold">{responseData?.email?.personal}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Aadhar Card</p>
                <p className="font-bold">
                  {responseData?.id_cards?.aadhar_number}
                </p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Pan Card</p>
                <p className="font-bold">
                  {responseData?.id_cards?.pan_number?.toUpperCase()}
                </p>
              </div>
            </div>
          </div>

          {/* Right: Actions */}
        </div>
      </section>
    </>
  );
};

export default UserDetail;
